import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { EuiProgress } from "@elastic/eui";
import { COLORS } from "Consts";

const PublicRouteContainer = () => {
  return (
    <Suspense fallback={<EuiProgress color={COLORS.$progressGreen} size="xs" />}>
      <Outlet />
    </Suspense>
  );
};

export default PublicRouteContainer;
